export default __webpack_public_path__ + "static/media/google-logo-9808.2431c88b.png";